export default __webpack_public_path__ + "static/media/aboutGold.b12e8739.svg";